import { isEmpty, is, prop, map, forEach, isNil } from 'ramda';
import { upload } from './request';
import { compressImage } from './compressImage';
const FormData = require('form-data');

export const uploadFiles = async (files) => {
  if (isNil(files) || (is(Array, files) && isEmpty(files))) return;
  const formData = new FormData();
  if (is(Array, files)) {
    const compressedFiles = await Promise.all(map(file => compressImage(prop('originFileObj', file)), files));
    forEach(compressedFile => formData.append('file', compressedFile), compressedFiles);
  } else {
    formData.append('file', await compressImage(files));
  }
  return await upload(formData);
};
